<template>
    <div class="account">
        <el-breadcrumb separator-class="el-icon-arrow-right" v-if="postList.headerTitle">
            <el-breadcrumb-item>合作产品路径期间</el-breadcrumb-item>
        </el-breadcrumb>
        <el-row class="main_header">
            <div class="main_header_item">
                <el-input v-model="queryParams.rid" placeholder="请输入RID" clearable @keyup.enter.native="getList(1)"></el-input>
            </div>
            <div class="main_header_item" v-if="postList.ppa_code">
                <el-input v-model="queryParams.ppa_code" placeholder="请输入PPA编码" clearable @keyup.enter.native="getList(1)"></el-input>
            </div>
            <div class="main_header_item">
                <vDropdown
                    model_key="type_code"
                    model_name="请选择类型"
                    :model_value_default="queryParams['type_code']"
                    request_uri="dropdownPpaType"
                    select_value="value"
                    @onDropChange="onDropChange"
                    ref="type_ref"
                ></vDropdown>
            </div>

            <div class="main_header_item">
                <vDropdown
                    model_key="business_unit_rid"
                    model_name="请选择业务单元"
                    :model_value_default="queryParams['business_unit_rid']"
                    request_uri="dropdownBusinessUnits"
                    select_value="rid"
                    @onDropChange="onDropChange"
                    ref="business_unit_rid_ref"
                ></vDropdown>
            </div>

            <div class="main_header_item">
                <vDropdown
                    model_key="product_rid"
                    model_name="请选择产品"
                    :model_value_default="queryParams['product_rid']"
                    request_uri="dropdownProducts"
                    :request_params="{ type_code: [11, 15, 91] }"
                    @onDropChange="onDropChange"
                    ref="product_rid_ref"
                ></vDropdown>
            </div>

            <div class="main_header_item">
                <el-date-picker
                    v-model="queryParams['date_range']"
                    type="daterange"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    value-format="yyyy-MM-dd"
                    size="small"
                    style="width: 300px"
                >
                </el-date-picker>
            </div>
            <div class="main_header_item">
                <vDropdown
                    model_key="province_sign"
                    model_name="请选择省份"
                    select_value="value"
                    :model_value_default="queryParams['province_sign']"
                    request_uri="dropdownProvinceSign"
                    @onDropChange="onDropChange"
                    ref="province_sign_ref"
                ></vDropdown>
            </div>
        </el-row>
        <div class="main_list">
            <div class="flex">
                <el-button size="small" plain @click="insert" icon="el-icon-plus" :loading="btnLoading">新增</el-button>
                <div class="main_header_btns">
                    <el-button type="primary" size="small" @click="getList(1)">搜索</el-button>
                    <el-button size="small" type="primary" plain @click="reset">重置</el-button>
                    <el-button size="small" plain icon="el-icon-bottom" @click="getList(2)" :loading="down_loading">下载</el-button>
                    <crm-upload obj="partner_product_account_period" :queryParams="queryParams"></crm-upload>
                    <draggableList :draggable="draggable" @isErrShow="onSetFieldDone"></draggableList>
                </div>
            </div>
            <el-table
                :data="tableData"
                border
                ref="tableDataRef"
                :max-height="this.$tableHeight"
                class="partner_product_account_period"
                @header-dragend="changeColWidth"
                v-loading="loading"
                element-loading-text="拼命加载中"
                element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(255, 255, 255, 0.8)"
                style="width: 100%"
            >
                <template v-for="(item, index) in colData">
                    <el-table-column
                        :key="index"
                        :prop="item.prop"
                        :label="item.title"
                        :min-width="item.width"
                        :sortable="item.sort"
                        align="left"
                        show-overflow-tooltip
                        v-if="colData[index].is_show"
                    >
                        <template slot-scope="scope">
                            <div v-if="in_array(item.prop, ['rid', 'ppa_code'])">
                                <el-link type="primary" @click="toDetail(scope.row, item.prop)" style="font-size: 11px"
                                    >{{ scope.row[item.prop] }}
                                </el-link>
                            </div>
                            <div v-else>
                                <span> {{ scope.row[item.prop] }} </span>
                            </div>
                        </template>
                    </el-table-column>
                </template>
                <el-table-column label="操作" width="120" fixed="right">
                    <template slot-scope="scope">
                        <el-tooltip class="item" effect="dark" content="复制" placement="top-start">
                            <i class="el-icon-menu" @click="copy(scope.row.rid)"></i>
                        </el-tooltip>
                        <el-tooltip class="item" effect="dark" content="编辑" placement="top-start">
                            <i class="el-icon-s-claim" @click="update(scope.row.rid)"></i>
                        </el-tooltip>
                        <el-tooltip class="item" effect="dark" content="删除" placement="top-start">
                            <i class="el-icon-delete-solid" @click="del(scope.row)"></i>
                        </el-tooltip>
                        <el-tooltip class="item" effect="dark" content="绩效分配" placement="top-start" v-if="scope.row.type_code != 2">
                            <i class="el-icon-s-operation" @click="performanceAssignment(scope.row.rid, 8)"></i>
                        </el-tooltip>
                        <!-- <el-tooltip class="item" effect="dark" content="绩效分配-应收" placement="top-start" v-if="scope.row.type_code != 2">
                            <i class="el-icon-receiving" @click="performanceAssignment(scope.row.rid, 6)"></i>
                        </el-tooltip>
                        <el-tooltip class="item" effect="dark" content="绩效分配-流向" placement="top-start" v-if="scope.row.type_code != 2">
                            <i class="el-icon-s-promotion" @click="performanceAssignment(scope.row.rid, 7)"></i>
                        </el-tooltip> -->
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination
                    background
                    layout="total,prev, pager, next, sizes, jumper"
                    @current-change="currentChange"
                    @size-change="sizeChange"
                    :page-sizes="[10, 25, 50, 75, 100]"
                    :current-page="queryParams.page"
                    :page-size="queryParams.row"
                    :total="total"
                ></el-pagination>
            </div>
        </div>
    </div>
</template>
<script>
import { onReSize, onSearch, in_array, onDelete } from '@/js/common.js';
import draggableList from '@/components/common/Drawer.vue';
import crmUpload from '@/components/common/Upload.vue';
import vSearchSelect from '@/components/common/dropdown/search.vue';

export default {
    inject: ['reload'],
    //注册draggable组件
    components: {
        draggableList,
        crmUpload,
        vSearchSelect
    },
    name: 'partnerProductAccountPeriodComponent',
    data() {
        return {
            draggable: {
                data_name: 'partner_product_account_period'
            },
            down_loading: false,
            btnLoading: false,
            loading: true,
            tableData: [],
            colData: [],
            total: 0,
            // sort: '', //排序参数
            // data_name: '', //排序参数
            queryParams: {}
        };
    },
    props: {
        postList: {
            type: Object
        }
    },
    beforeMount() {
        this.recoveryQueryParams('page');
    },
    mounted() {
        this.$nextTick(() => {
            this.selectedColData(); //筛选列
            this.recoveryQueryParams();
            if (this.postList.params) {
                //如果详情列表需要搜索参数 重置按钮放出来 注意 传来的id不可被重置掉
                this.queryParams.row = 10;
                this.queryParams.ppa_rid = this.postList.params.ppa_rid;
                this.getList(0);
            } else {
                this.getList(0); //获取列表
            }
        });
    },
    methods: {
        in_array,
        //跳转详情
        toDetail(row, prop) {
            if (prop == 'rid' && row.rid) {
                this.$router.push({
                    path: '/partnerProductAccountPeriodDetail',
                    query: {
                        id: row.rid,
                        ppa_rid: row.ppa_rid
                    }
                });
            } else if (prop == 'ppa_code' && row.ppa_rid) {
                this.$router.push({
                    path: '/partnerProductAccountDetail',
                    query: {
                        id: row.ppa_rid
                    }
                });
            }
        },
        initQueryParams() {
            this.queryParams = {
                page: 1,
                row: 25,
                is_export: 0,
                ppa_rid: this.postList.params && this.postList.params.ppa_rid ? this.postList.params.ppa_rid : ''
            };

            this.saveQueryParams();
        },
        onDropChange(key, value) {
            this.queryParams[key] = value;
        },
        saveQueryParams() {
            if (!this.postList.params) {
                localStorage.setItem('partner_product_account_period_params', JSON.stringify(this.queryParams));
            }
        },
        // 分页参数需要在beforeMount初始化，先兼容下
        recoveryQueryParams(type = 'common') {
            //详情内调用不用本地存储的params
            if (!this.postList.params) {
                //列表页面调用 优先取本地存储
                const queryParams = JSON.parse(localStorage.getItem('partner_product_account_period_params'));
                if (queryParams) {
                    if (type == 'common') {
                        this.queryParams = queryParams;
                    } else {
                        this.queryParams.page = queryParams.page || 1;
                        this.queryParams.row = queryParams.row || 25;
                    }
                } else {
                    this.initQueryParams();
                }
            }
        },
        //子组件更新完毕
        onSetFieldDone(data) {
            //刷新下页面
            this.reload();
        },
        //列宽改变事件
        changeColWidth(nw, ow, col, evt) {
            onReSize('partner_product_account_period', this);
        },
        //筛选列
        selectedColData() {
            this.colData = JSON.parse(localStorage.getItem('dataList')).partner_product_account_period;
        },
        // 获取列表 0-非搜索 1-搜索 2-下载
        getList(search_type = 0) {
            onSearch(search_type, this, 'partnerProductAccountPeriodLists');
        },
        currentChange(page) {
            this.queryParams.page = page;
            this.saveQueryParams();
            this.getList(0);
        },
        sizeChange(row) {
            this.queryParams.row = row;
            this.saveQueryParams();
            this.getList(0);
        },
        reset() {
            this.initQueryParams();
            this.$refs.type_ref.reset();
            this.$refs.business_unit_rid_ref.reset();
            this.$refs.product_rid_ref.reset();
            this.$refs.province_sign_ref.reset();
            this.getList();
        },
        //新增
        insert() {
            this.$router.push({
                path: 'partnerProductAccountPeriodEdit',
                query: {
                    type: 'insert',
                    ppa_rid: this.postList.params && this.postList.params.ppa_rid ? this.postList.params.ppa_rid : ''
                }
            });
        },
        //复制
        copy(rid) {
            this.$router.push({
                path: 'partnerProductAccountPeriodEdit',
                query: {
                    type: 'copy',
                    id: rid,
                    ppa_rid: this.postList.params && this.postList.params.ppa_rid ? this.postList.params.ppa_rid : ''
                }
            });
        },
        //编辑
        update(rid) {
            this.$router.push({
                path: 'partnerProductAccountPeriodEdit',
                query: {
                    type: 'update',
                    id: rid,
                    ppa_rid: this.postList.params && this.postList.params.ppa_rid ? this.postList.params.ppa_rid : ''
                }
            });
        },
        //删除
        del(row) {
            onDelete(row.id, this, 'partnerProductAccountPeriodDelete', row.rid);
        },
        performanceAssignment(rid, object_type_code) {
            this.$router.push({
                path: 'performanceAssignmentEdit',
                query: {
                    type: 'insert',
                    object_type_code: object_type_code,
                    object_rid: rid
                }
            });
        }
    }
};
</script>
<style lang="scss" scoped>
/deep/ .el-table__empty-block {
    width: 100% !important;
    min-width: 100% !important;
    max-width: 100% !important;
    padding-right: 100% !important;
}
</style>